import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertTriangle, FiRefreshCw } = FiIcons;

const ErrorMessage = ({ message, onRetry }) => {
  return (
    <div className="text-center max-w-md">
      <SafeIcon icon={FiAlertTriangle} className="text-4xl text-red-500 mx-auto mb-4" />
      <h3 className="text-lg font-semibold text-gray-900 mb-2">
        Something went wrong
      </h3>
      <p className="text-gray-600 mb-6">
        {message || 'Unable to load product data. Please try again.'}
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="inline-flex items-center space-x-2 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
        >
          <SafeIcon icon={FiRefreshCw} className="text-sm" />
          <span>Try Again</span>
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;